import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { KitService } from '../../services/kit.service';
import { StatService } from '../../services/stat.service';
import { ElementService } from '../../services/element.service';
import { DragulaService } from 'ng2-dragula';
import { ToasterService } from 'angular2-toaster';
import { Observable } from 'rxjs';

import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/filter';
import {Kit} from '../../services/kit';
import {FolderService} from '../../services/folder.service';
import {Folder} from '../../services/folder';

@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.css']
})
export class LibraryComponent implements OnInit {
  kits = [];
  kitId;
  elementId;
  kits$: Observable<Kit[]>;

  constructor(
    private folderService: FolderService,
    private kitService: KitService,
    private statService: StatService,
    private elementService: ElementService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dragulaService: DragulaService,
    private toasterService: ToasterService
  ) {
    this.kits$ = this.kitService.all$();
  }

  ngOnInit() {

    this.kitService.getAll().subscribe(kits => {
      this.kits = kits;

      // Set up a drag & drop "bag" for each group of elements
      this.kits.forEach((kit, index) => {
        this.dragulaService.setOptions(`element-bag-kit-${kit.id}`, {
          moves: function (el, container, handle) {
            return handle.classList.contains('link-move-inner');
          }
        });
      });

    });

    this.statService.getAll();

    // Set drag and drop options
    this.dragulaService.setOptions('kit-bag', {
      moves: function (el, container, handle) {
        return handle.classList.contains('link-move') && !handle.classList.contains('link-move-inner');
      }
    });

    // Send up new kit/element order on drop
    this.dragulaService.dropModel.subscribe((value) => {
      const bagName = value[0];
      const updatedModel = this.dragulaService.find(bagName).drake.models[0];

      if (bagName === 'kit-bag') {
        this.kitService.updateOrder(updatedModel).subscribe(() => {
          this.toasterService.pop('success', 'Success', 'Kit order saved');
        });
      }
      if (bagName.includes('element-bag')) {

        // this.elementService.updateOrder(updatedModel).subscribe(() => {
        //   this.toasterService.pop('success', 'Success', 'Kit order saved');
        // });
      }
    });

    this.dragulaService.drop.subscribe((value) => {
      this.onDrop(value.slice(1));
    });

    // Subscribe to route changes
    // Then subscribe to the params from the route changes
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .map(() => this.activatedRoute.queryParams)
      .mergeMap(paramSubject => { return paramSubject })
      .subscribe(params => {
        this.kitId = +params['kit'];
        this.elementId = +params['element'];
      });
  }


  onDrop(args) {
    let [child, parentContainer] = args;

    let parentId  = parentContainer.id;
    let childId   = child.id;
    let folderId  = null;
    let kitId     = null;
    let elementId = null;

    if (/^element-/.test(childId)) {
      elementId = +(childId.split('-')[1]);
    }

    if (/^folder-/.test(parentId)) {
      folderId = +(parentId.split('-')[1]);
    }

    if (/^kit-/.test(parentId)) {
      kitId = +(parentId.split('-')[1]);
    }


    if (elementId && folderId) {
      let element = this.elementService.find(elementId);

      this.elementService.moveElementToFolder(
        element.id,
        folderId
      ).subscribe(() => {
        this.toasterService.pop('success', 'Success', 'Element moved to folder')
      });

    } else if (elementId && kitId) {

      this.elementService.moveElementToFolder(
        elementId,
        null
      ).subscribe(() => {
        this.toasterService.pop('success', 'Success', 'Element moved to root folder')
      });
    }

  }

  duplicate(kitId: number, elementId: number) {
    this.elementService.duplicateElement(kitId, elementId).subscribe();
  }

  ngOnDestroy() {
    try {
      // Drag and drop cleanup
      this.dragulaService.destroy('kit-bag');

      this.kits.forEach((kit, index) => {
        this.dragulaService.destroy(`element-bag-${index}`);
      });
    } catch (e) {
      // fail silently on js undefined bag, error happens when navigating outside of component
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/library/library.component.ts